import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import {
	getAllMetricsByCategory,
} from "../../state/metricListSlice";
import classes from "./MetricList.module.css";

import { getAllClients, selectAllClients } from "../users/usersSlice"
// import { getAllEventsTemplates } from "../EventsView/eventsViewSlice";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";


const ClientMetricList = () => {

	const userID = useSelector((state) => state.users.current_user?.user_id_number);

  const dispatch = useDispatch()
  const statusDispatch = useApiStatusDispatch();


	const [metricSort, setMetricSort] = useState(false)
	const [isLoading, setIsLoading] =useState(false)

	//gets all metrics upon client select or dispatch
	useEffect(() => {
		setIsLoading(true)
		let include_progress_data=0
		let include_empty_groups=1
		let	client_Id = userID
		let type = 'client'

		const payload = {
			type,
			client_Id,
			include_progress_data,
			include_empty_groups
		}
		dispatch(getAllMetricsByCategory(payload)).then(() => {
			setIsLoading(false)
		})
	}, [])

  // const metrics = Object.values(useSelector((state) => state.metrics.entities))

	const metrics = Object.values(useSelector((state) => state.metrics.entities)).sort(function(a,b){
		let textA = a.assessment_name.toUpperCase();
		let textB = b.assessment_name.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	}).sort(function(a,b){
		let textA = a.categorization.toUpperCase();
		let textB = b.categorization.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	})

	// const metricsListSorted = Object.values(useSelector((state) => state.metrics.entities)).sort(function(a,b){
	// 	let textA = a.assessment_name.toUpperCase();
	// 	let textB = b.assessment_name.toUpperCase();
	// 	return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	// }).sort(function(a,b){
	// 	let textA = a.categorization.toUpperCase();
	// 	let textB = b.categorization.toUpperCase();
	// 	return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	// })

	// //upon sort metrics button click grabs the button then checks if metricSort is true
	// // either sets to false and removes the color class or true and adds color class
	// const handleMetricSort =() => {
	// 	let button =document.getElementById('metricsSortButton')
	// 	if(metricSort){
	// 		setMetricSort(false)
	// 		button.classList.remove(classes.sortSelected)
	// 	} else {
	// 		setMetricSort(true)
	// 		button.classList.add(classes.sortSelected)
	// 	}
	// }     Sorted metrics here incase we want to add a sort button for the basic view

	return (
		<div className={classes.AssessmentList} id="containerDiv">
			<div className={classes.Header}>Metrics</div>
			<hr />
      <div className={classes.Subtext}>
						Below are the different progress metrics that can be measured and
						recorded on the 
						<Button
							variant='link'
							className={classes.assessmentLinkButton}
							// style={{padding:'0px 3.6px 0px 3.6px', font:'inherit', fontSize:'inherit'}}
							as={Link}
							to={`/metric-graphs?clientId=${userID}`}
						> Progress</Button>page.
						</div>
      <div style={{ width: "100%", marginTop: 25 }}>
					{/* <Card.Body> */}
          <Table bordered hover className={classes.metricListTable}>
            <thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
              <tr>
                <th> Metric Name</th>
                <th>Description</th>
                <th>Category</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? 
                <div style={{ display: 'flex', justify_content: 'center' }}>
                  <Spinner animation="border" role="status" variant="primary" >
                  </Spinner>
                </div> 
              : 
                <>
                {metrics?.map((val, index) => (
                <tr>
                  <td>
                    <span style={{fontWeight:'bold'}}>
                      {val?.assessment_name}
                    </span>
                  </td>
                  <td>{val?.description}</td>
                  <td>{val?.categorization}</td>
                </tr>
            ))}
            </>
            }
            </tbody>
            </Table>
          {/* </Card.Body> */}
      </div>
		</div>
	);
};
export default ClientMetricList;
